import axios from 'axios';

export async function getUser() {
  return await axios.get(`/self-tours/api/v1/user`).then((response) => response.data);
}
